import { Cards, TokenTemplates } from "./../models/card.model";
import { v4 as uuid } from "uuid";
import { ObjectUtils } from "../../../../../utils/object.utils";

export class CardUtils {
  static toArray(object: Object) {
    let result = [];

    for (let obj in object) {
      result.push(object[obj]);
    }
    return result;
  }

  /**
   * @Input:
   * cards = {
   *  attr1: [card, card],
   *  attr2: [card, card]
   * }
   * @Output
   * cards = {
   *  attr1: [cardWithUniqId, cardWithUniqId],
   *  attr2: [cardWithUniqId, cardWithUniqId]
   * }
   */
  static generateCardsId(cards: Cards): Cards {
    let nc = ObjectUtils.deepClone(cards);
    for (let subCards of Object.keys(cards)) {
      for (let card of cards[subCards]) {
        card['id'] = uuid();
      }
    }
    return nc;
  }

  static rotate(card) {
    if (card["actions"] === undefined) {
      card["actions"] = {};
    }
    card["actions"]["rotate"] = card["actions"]["rotate"]
      ? !card["actions"]["rotate"]
      : true;
    return card;
  }

  static token($event: {
    card;
    counterChangeEvent: { template: string; value: number };
  }) {
    if ($event.card["tokens"] === undefined) {
      $event.card["tokens"] = {};
    }
    if (
      [
        TokenTemplates.STUNT,
        TokenTemplates.ENRAGE,
        TokenTemplates.WARD
      ].includes($event.counterChangeEvent.template as TokenTemplates)
    ) {
      $event.card["tokens"][$event.counterChangeEvent.template] =
        $event.counterChangeEvent.value === 0 ? 1 : 0;
    } else if (
      $event.card["tokens"][$event.counterChangeEvent.template] === undefined
    ) {
      $event.card["tokens"][$event.counterChangeEvent.template] =
        $event.counterChangeEvent.value;
    } else {
      $event.card["tokens"][$event.counterChangeEvent.template] +=
        $event.counterChangeEvent.value;
    }
  }

  static shuffle(a) {
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
  }
}
